import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import {
  failurelistReadingPrompt,
  successlistReadingPrompt,
} from "./ListReadingPromptSlice";
import { PayloadAction } from "@reduxjs/toolkit";
import { IReadingPrompt } from "../../../Pages/DashboardUser/IDashboardUser";

// list
const ListReadingPromptApi = (action: PayloadAction<IReadingPrompt>) => {
  const params = { ...action.payload };

  if (
    params.keyword === null ||
    params.keyword === undefined ||
    params.keyword === "" ||
    params.keyword === "null" ||
    params.keyword === "undefined"
  ) {
    delete params.keyword;
  }

  return api.get("/api/question/main-questions", { params });
};

export function* ListReadingPromptCall(action: PayloadAction<IReadingPrompt>) {
  try {
    const response: AxiosResponse = yield call(ListReadingPromptApi, action);
    yield put(successlistReadingPrompt(response.data));
  } catch (error) {
    yield put(failurelistReadingPrompt(error));
  }
}
